import React, { useState, useEffect } from "react";
import { Table, Accordion, Button } from "react-bootstrap";
import { auditLog } from "./store";
import moment from "moment";
import AuditSlotTimePicker from "./AuditSlotTimePicker";

function AuditLog({ userid }) {
  const { getAudtiLogs, auditData } = auditLog();
  const [expandedEntries, setExpandedEntries] = useState([]);
  const [selectedDays, setSelectedDays] = useState({});

  useEffect(() => {
    getAudtiLogs(userid);
  }, [userid]);

  const toggleEntryExpansion = (entryId) => {
    setExpandedEntries((prev) => {
      if (prev.includes(entryId)) {
        return prev.filter((id) => id !== entryId);
      } else {
        setSelectedDays((prevSelectedDays) => ({
          ...prevSelectedDays,
          [entryId]: "0", // Reset to Sunday when a new log is expanded
        }));
        return [...prev, entryId];
      }
    });
  };

  const handleDaySelect = (entryId, day) => {
    setSelectedDays((prevSelectedDays) => ({
      ...prevSelectedDays,
      [entryId]: day,
    }));
  };

  const getMetaData = (originalData) => {
    const { slots, ...otherDetails } = originalData || {}; // Destructure slots and remaining details
    return otherDetails;
  };

  return (
    <div className="changes-tab-content">
      {auditData?.map((logEntry) => (
        <div key={logEntry?._id}>
          {logEntry?.data && (
            <Accordion className="mt-3" activeKey={expandedEntries}>
              <Accordion.Item eventKey={logEntry?._id}>
                <Accordion.Header
                  onClick={() => toggleEntryExpansion(logEntry?._id)}
                >
                  <Button
                    className="collapse-button btn-primary"
                    onClick={(evt) => {
                      evt.stopPropagation();
                      toggleEntryExpansion(logEntry?._id);
                    }}
                  >
                    {expandedEntries.includes(logEntry?._id) ? "-" : "+"}
                  </Button>
                  Changes on{" "}
                  {moment
                    .utc(logEntry.createdAt)
                    .add(5, "hours")
                    .add(30, "minutes")
                    .format()}
                  <span className="ps-5">
                    {logEntry.isNewUser
                      ? `${logEntry?.authorName} made changes to the profile`
                      : `${logEntry?.authorName} created this profile`}
                  </span>

                </Accordion.Header>
                <Accordion.Body>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th style={{ width: "50%" }}>Original Value</th>
                        <th style={{ width: "50%" }}>Modified Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div
                            style={{
                              padding: "10px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              backgroundColor: "white",
                            }}
                          >
                            {JSON.stringify({
                              level: logEntry?.data?.originalUserData?.level,
                              meta: getMetaData(
                                logEntry?.data?.originalUserData?.meta
                              ),
                            })}
                          </div>
                          {logEntry?.data?.originalUserData?.meta?.slots && (
                            <AuditSlotTimePicker
                              slot={
                                logEntry?.data?.originalUserData?.meta?.slots
                              }
                              selectedDay={selectedDays[logEntry?._id]}
                              handleDaySelect={(day) =>
                                handleDaySelect(logEntry?._id, day)
                              }
                            />
                          )}
                        </td>
                        <td>
                          <div
                            style={{
                              padding: "10px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              backgroundColor: "white",
                            }}
                          >
                            {JSON.stringify({
                              level: logEntry?.data?.originalUserData?.level,
                              meta: getMetaData(
                                logEntry?.data?.originalUserData?.meta
                              ),
                            })}
                          </div>
                          {logEntry?.data?.modifiedData?.meta?.slots && (
                            <AuditSlotTimePicker
                              slot={logEntry?.data?.modifiedData?.meta?.slots}
                              selectedDay={selectedDays[logEntry?._id]}
                              handleDaySelect={(day) =>
                                handleDaySelect(logEntry?._id, day)
                              }
                            />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          )}
        </div>
      ))}
    </div>
  );
}

export default AuditLog;
